var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "VegetativeMonitoringTabularView",
    _vm._b(
      {
        attrs: {
          headers: _vm.headers,
          collectionItems: _vm.collectionItems,
          value: _vm.dialog,
          showAllValues: _vm.showAllValues,
          loading: _vm.loading,
          isEditing: _vm.isEditing,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
          "update:isEditing": function ($event) {
            _vm.isEditing = $event
          },
          "update:is-editing": function ($event) {
            _vm.isEditing = $event
          },
          "update-show-all-values": function ($event) {
            return _vm.$emit("update:showAllValues", $event)
          },
          refresh: function ($event) {
            return _vm.$emit("refresh")
          },
        },
      },
      "VegetativeMonitoringTabularView",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }